import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';

export const OutputNodeView = memo(function OutputNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <div className="flow-node flow-node--terminal rounded-full border-2 border-orange-500 bg-orange-50 shadow-sm">
      <div className="flow-node__title text-center font-semibold text-orange-700">{getNodeDisplayLabel('output', displayLanguage)}</div>
      <Handle type="target" position={Position.Left} className="!bg-orange-500" />
    </div>
  );
});